import React from "react";
import { FaGithub } from "react-icons/fa";
import { SiLeetcode, SiHackerrank, SiCodio, SiCodechef } from "react-icons/si";
import gfg from "../images/gfg.png";
import { RiExternalLinkLine } from "react-icons/ri";

export default function Profiles() {
  return (
    <>
      <h1
        className="text-2xl ml-20 mt-20"
        data-aos="zoom-in-left"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      >
        Profiles
      </h1>
      <div className="flex flex-col items-center justify-center min-h-[75vh] ">
        <div className="flex flex-wrap justify-center gap-6 max-w-4xl">
          {/* GitHub Icon */}
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://github.com/rayyush"
              alt="github"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="1500"
              data-aos-easing="ease-in"
            >
              <FaGithub size={50} color="white" />
            </a>
          </div>
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://codolio.com/profile/rayyush"
              alt="codolio"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="1600"
              data-aos-easing="ease-in"
            >
              <SiCodio size={50} color="white" />
            </a>
          </div>
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://www.hackerrank.com/profile/ayush070503"
              alt="hackerrank"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="1700"
              data-aos-easing="ease-in"
            >
              <SiHackerrank size={50} color="white" />
            </a>
          </div>
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://leetcode.com/u/ayush0705/"
              alt="leetcode"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="1800"
              data-aos-easing="ease-in"
            >
              <SiLeetcode size={50} color="white" />
            </a>
          </div>
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://www.geeksforgeeks.org/user/rayyush/"
              alt="gfg"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="1900"
              data-aos-easing="ease-in"
            >
              <img
                src={gfg}
                alt="gfg"
                className="h-full w-full object-cover rounded-full"
              />
            </a>
          </div>
          <div className="flex items-center justify-center h-32 w-32 rounded-full bg-gray-800 p-2">
            <a
              href="https://www.codechef.com/users/ayush0705"
              alt="codechef"
              target="_blank"
              rel="noreferrer"
              data-aos="zoom-in-left"
              data-aos-duration="2000"
              data-aos-easing="ease-in"
            >
              <SiCodechef size={50} color="white" />
            </a>
          </div>
        </div>

        {/* Centered Buttons */}
        <div
          className="flex space-x-4 mt-10"
          data-aos="fade-left"
          data-aos-duration="2000"
          data-aos-easing="ease-in-out"
        >
          <div className="inline-block bg-gray-200 border border-gray-300 rounded-lg px-6 py-3 transition-colors duration-300 ease-in-out hover:bg-gray-800 hover:text-white">
            <a
              href="https://drive.google.com/file/d/1Ee1QqFX2B46WFxgtIqdb5bY3idNYtD-l/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="flex items-center text-gray-800 hover:text-white font-semibold"
            >
              <span>Resume</span>
              <RiExternalLinkLine className="ml-1" />
            </a>
          </div>

          <div className="inline-block bg-blue-500 border border-blue-600 rounded-lg px-6 py-3 transition-colors duration-300 ease-in-out hover:bg-blue-600 hover:text-white">
            <a
              href="mailto:ayush070503@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="flex items-center text-white font-semibold"
            >
              <span>Hire Me Now</span>
            </a>
          </div>
        </div>
      </div>

      <hr className="border-gray-600" />
      <div className="w-full h-20 flex justify-center items-center">
        <p>Designed & Developed by RAYYUSH with 🤍</p>
      </div>
    </>
  );
}
